/* global btoa */
let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let esUtils = require("ES/utils/esUtils");
let ImageURLs = require("../../utils/ImageURLs");
let CognitoForm = require("./CognitoForm");
let SigninForm = require("./SigninForm");
let MaintenanceNotices = require("./MaintenanceNotices");
let ForgotForm = require("./ForgotForm");
let qs = require("qs");
let AuthedUserSession = require("../../utils/AuthedUserSession");

module.exports = dd.createClass({
  getInitialState() {
    return { show_forgot_password: false };
  },
  __toggleForgotPasswordView: esUtils.wrapPreventDefault(function () {
    this.setState({ show_forgot_password: !this.state.show_forgot_password });
  }),
  render() {
    let { login_locked, maintenance_notices } = this.props;
    let body = null;
    let footer = null;
    if (this.state.show_forgot_password) {
      body = ForgotForm();
      footer = dd.div(
        { style: { marginTop: 10 }, className: "text-center" },
        dd.a(
          { href: "#", onClick: this.__toggleForgotPasswordView },
          dd.i({ className: "fa fa-arrow-left" }),
          " Back to sign in"
        )
      );
    } else {
      const use_cognito =
        AuthedUserSession.is_cognito ||
        _.has(qs.parse(_.get(window.location, "search").replace("?", "")), [
          "cognito",
        ]);
      body = SigninForm({ login_locked });
      if (use_cognito) {
        body = CognitoForm({ login_locked });
      }
      footer = dd.div(
        { style: { marginTop: 10 } },
        !use_cognito &&
          dd.a(
            {
              href: "#",
              className: "pull-left",
              onClick: this.__toggleForgotPasswordView,
            },
            "Forgot Password?"
          ),
        !AuthedUserSession.is_privatelabel
          ? dd.a(
              {
                href: "https://www.espeakers.com/speakers/plans-pricing",
                className: "pull-right",
              },
              "Need an account?"
            )
          : null,
        dd.div({ className: "clearfix" })
      );
    }

    // set up the staff login for solution tree
    let pl_footer = dd.footer(
      { className: "text-muted text-center" },
      dd.p({}, "powered by eSpeakers")
    );
    let pl_header = null;
    if (AuthedUserSession.is_st_family) {
      let redirect_uri = `https://${
        AuthedUserSession.is_staging
          ? "balboa-st-staging.espeakers.com"
          : "balboa-st.espeakers.com"
      }/admin/connect/cognito?state=${btoa(
        `${window.location.protocol}//${window.location.host}/admin/token-callback/[[token]]|${window.location.protocol}//${window.location.host}/admin/unverified?error=[[error]]`
      )}`;
      pl_footer = dd.footer(
        { className: "text-muted text-center" },
        dd.a(
          { claasName: "link", href: redirect_uri },
          "Staff login here ",
          dd.i({ className: "fa fa-arrow-right" })
        ),
        dd.p({}, "powered by eSpeakers"),
        AuthedUserSession.is_cognito &&
          dd.p(
            { className: "small" },
            "You may receive texts when signing into eSpeakers services. Message and data rates apply. You can reply with STOP to discontinue."
          )
      );
      pl_header = dd.h4({}, "Associate Login");
    }

    return dd.div(
      {},
      dd.div({ className: "clearfix" }),
      dd.div(
        { style: { margin: "50px auto 0 auto", width: 300 } },
        dd.div(
          { className: "well text-center" },
          dd.img({
            src: ImageURLs.logo,
            style: { marginBottom: 15, maxWidth: "100%" },
          }),
          pl_header,
          body,
          footer
        ),
        pl_footer
      ),
      dd.div(
        { style: { margin: "50px auto 0 auto", width: 425 } },
        MaintenanceNotices({ notices: maintenance_notices })
      )
    );
  },
});



// WEBPACK FOOTER //
// ./src/components/signin/index.js